<template>
  <div>
    <el-table :data="auditTableData" stripe style="width: 100%">
      <el-table-column width="150px" label="Date" prop="createdAt" sortable>
        <template slot-scope="scope">
          <span>{{ readableDate(scope.row.createdAt) }}</span>
        </template>
      </el-table-column>
      <el-table-column width="250px" label="User" prop="email" sortable></el-table-column>
      <el-table-column width="150px" label="Type" prop="type" sortable></el-table-column>
      <el-table-column label="Data" prop="subject"></el-table-column>
    </el-table>
  </div>
</template>

<script>
import { getAudits } from "../api";

export default {
  name: "Logs",
  props: {},
  data: function() {
    return {
      auditTableData: []
    };
  },
  methods: {
    readableDate: function(date) {
      let localDate = new Date(date).toLocaleString("default");
      return localDate;
    },
    async loadData() {
      this.auditTableData = await getAudits();
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
